import { FETCH_PRODUCT,CREATE_PRODUCT } from "constants/ActionTypes";

const INIT_STATE_PRODUCT = [];

export default (state = INIT_STATE_PRODUCT, action ) => {
    switch (action.type) {
        case FETCH_PRODUCT: {
            if (action.payload == undefined) {
                return state;
            } else {
                const newState = action.payload.map( (value) => {
                    return value
                });
                return newState;
            }
        } 
        case CREATE_PRODUCT: {
            console.log(action)
            if (action.payload == undefined) {
                return state;
            } else {
                const newState = action.payload.map( (value) => {
                    return value
                });
                return newState;
            }
        } 
     
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/appRedux/reducers/Product.js